import * as yup from "yup";

export interface IJobSkills {
    id?: number,
    department_Id: number,
    job_Profile_Id: number,
    skills: string[],
}


export const emptyJobSkills: IJobSkills = {
    id: undefined,
    department_Id: 0,
    job_Profile_Id: 0,
    skills: [],
};

export const schema = yup.object().shape({
    department_Id: yup.number().min(1, "Department is required").required("Department is required").typeError("Department is required"),
    job_Profile_Id: yup.number().min(1, "Job Profile is required").required("Job Profile is required").typeError("Job Profile is required"),
    skills: yup.array().min(1,"At least one skill is required").required("At least one skill is required").typeError("At least one skill is required"),
});
